
const getURL = () => {
  let url =
    import.meta.env.VITE_SITE_URL ?? // Set this to your site URL in production env.
    import.meta.env.VITE_VERCEL_URL ?? // Automatically set by Vercel.
    'http://localhost:5000/' // Your local dev port
  
  // Make sure to include `https://` when not localhost.
  url = url.startsWith('http') ? url : `https://${url}`
  
  // Make sure to include a trailing `/`.
  url = url.endsWith('/') ? url : `${url}/`
  
  return url
}

// Get URL for auth redirects (with browser routing)
const getAuthRedirectURL = (path: string = 'login') => {
  const baseUrl = getURL()
  // For email confirmations, we need to handle the redirect properly
  if (path.includes('?')) {
    // If path already contains query params, append them to the base URL
    return `${baseUrl}${path}`
  }
  return `${baseUrl}${path}`
}

// Specific URL for email confirmations - point to confirm-signup page
const getEmailConfirmationURL = () => {
  const baseUrl = getURL()
  return `${baseUrl}confirm-signup`
}

export { getURL, getAuthRedirectURL, getEmailConfirmationURL }
